exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".underline[data-v-43e21330]{text-decoration:underline}", ""]);

// exports
